import { render, staticRenderFns } from "./topico_item_big.vue?vue&type=template&id=715606e9&"
import script from "./topico_item_big.vue?vue&type=script&lang=js&"
export * from "./topico_item_big.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('715606e9')) {
      api.createRecord('715606e9', component.options)
    } else {
      api.reload('715606e9', component.options)
    }
    module.hot.accept("./topico_item_big.vue?vue&type=template&id=715606e9&", function () {
      api.rerender('715606e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/topicos/topico_item_big.vue"
export default component.exports